<template>
  <!-- 子应用容器 -->
  <div id="subapp-viewport" class="micro-container">
    <!-- 微前端加载状态 -->
    <el-row>
      <el-col :sm="24" :lg="24" v-if="$root.microError">
        <el-result icon="error" title="遇到错误" :subTitle="$root.microError">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="reload()"
              >刷新页面</el-button
            >
          </template>
        </el-result>
      </el-col>

      <div v-else-if="$root.microLoading" style="text-align: center">
        Loading...
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Container",
  methods: {
    // 刷新页面
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* 子应用容器样式隔离 */
.micro-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}

/* 确保子应用的样式不会溢出 */
.micro-container >>> * {
  box-sizing: border-box;
}
</style>
